import React, { Component } from "react";
import { Grade, ImageView , OfficialAuth} from "c-up-ui";
import Url from 'c-url';
import lang from "../lang/index";

class ListItemTemp extends Component {
    static defaultProps = {
        item: {} 
    }
    
    constructor(props) {
        super(props);

        this.state = {
            style: {}
        }
    }

    componentDidMount(){        
        let resourceDesp = this.props.item.content.resourceDesp;      
        let width = $(this.refs.wrap).width();

        if (resourceDesp) {
            resourceDesp = JSON.parse(resourceDesp);
            style = {
                width: width,
                height: width * resourceDesp.height / resourceDesp.width
            }
        } else {
            style = {
                width: width,
                height: 'auto'
            }
        }

        this.setState({
            style: style
        });
    }

    render() {
        let item = this.props.item;
        let resourceDesp = item.content.resourceDesp;

        return (
            <li className="video-item" >  
                <div className="box" style={{ opacity: this.state.opacity }}>                
                    <div className="video-box">
                        <img className="cover" src="//g-cdn.pengpengla.com/oauthgame/html5/20170606/0c0688e97bf70219860dc285cf8a3fdc.png" style={this.state.style}/>
                        <div className="text"></div>
                        <div className="mask"></div>
                    </div>

                    <div className="author-box">
                        <div className="title">{item.content.text}</div>
                        <div className="user">
                            <div className="avatar">
                                <ImageView src="//g-cdn.pengpengla.com/oauthgame/html5/20170606/0c0688e97bf70219860dc285cf8a3fdc.png"  size="20" circle/>
                            </div>
                            <div className="content">
                                <span className="nickname"></span>
                                <ul className="feed-count">
                                    <li className="scan hidden" >
                                        <i></i>
                                    </li>
                                    <li className="like">
                                        <i></i>
                                    </li>
                                    <li className="comment hidden">
                                        <i></i>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>              
            </li>
        );
    }

}


class ListItem extends Component {
    static defaultProps = {
        item: {}
    };

    constructor(props) {
        super(props);

        this.state = {
            style: {}
        }
    }

    onClick(rid, dynamicId) {
        let _url = Url.delQuery(location.href, 'dynamicId');

        _url = Url.delQuery(_url, 'rid');

        _url = Url.addParam(_url, {
            dynamicId: longToString(dynamicId)
        });

         _url = Url.addParam(_url, {
            rid: longToString(rid)
        });

        location.href = _url;
        // hashHistory.push('/videodetail/' + rid + '/' + dynamicId);
    }

    componentDidMount(){        
        let resourceDesp = this.props.item.content.resourceDesp;      
        let width = $(this.refs.wrap).width();

        if (resourceDesp) {
            resourceDesp = JSON.parse(resourceDesp);
            style = {
                width: width,
                height: width * resourceDesp.height / resourceDesp.width
            }
        } else {
            style = {
                width: width,
                height: 'auto'
            }
        }

        this.setState({
            style: style
        });
    }

    render() {
        let item = this.props.item;
        let resourceDesp = item.content.resourceDesp;        

        return (
            <li className="video-item" onClick={this.onClick.bind(this, item.rid, item.dynamicId)}>                
                <div className="box" ref="wrap">                
                    <div className="video-box">
                        <img className="cover" src={item.content.coverUrl} style={this.state.style}/>
                        <div className="mask"></div>
                    </div>
                    <div className="author-box">
                        <div className="title">{item.content.text}</div>
                        <div className="user">
                            <div className="avatar">
                                <ImageView src={item.userInfo.avatar}  size="20" circle/>
                            </div>
                            <div className="content">
                                <span className="nickname">{item.userInfo.userName}</span>
                                <ul className="feed-count">
                                    <li className="scan" >
                                        <i></i>
                                        <em>{ item.playNum || 0 }</em>
                                    </li>
                                    <li className="like hidden" data-liked={item.liked ? 1 : 0 }>
                                        <i></i>
                                        <em>{ item.likeNum || 0 }</em>
                                    </li>
                                    <li className="comment hidden" >
                                        <i></i>
                                        <em>{ item.commentNum || 0 }</em>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </li>
        );
    }
}

export {
    ListItem,
    ListItemTemp
};



// WEBPACK FOOTER //
// ./js/videolist/item.js